export function isInArray<T>(
    itemId: string,
    array: Array<T>,
    key: string = "id",
) {
    let existsInArray = false;
    const index = getIndex(itemId, array, key);
    if (index > -1) existsInArray = true;

    return existsInArray;
}
export function getIndex<T>(itemId: string, array: Array<T>, key: string) {
    //@ts-ignore
    const index = array.map((item) => item[key]).indexOf(itemId);
    return index;
}

// Returns a copy of array with the item in it.
export function addToArray<T>(item: T, array: Array<T>): Array<T> {
    if (array.length === 0) {
        return [item]
    } else {
        return [...array, item]
    }
}

